import React, { lazy } from 'react';
import { MapPin, Phone, Facebook, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-burgundy-dark text-cream pt-20 pb-10 border-t-4 border-orange" data-id="element-50">
      <div className="max-w-7xl mx-auto px-6" data-id="element-51">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16 text-center md:text-left" data-id="element-52">
          {/* Brand Col */}
          <div className="flex flex-col items-center md:items-start" data-id="element-53">
            <img src="https://cdn.magicpatterns.com/uploads/e7AKa5cjKZiQRF2tewCqsN/ChatGPT_Image_22_may_2026,_08_47_06_p.m..png" alt="The Happy Taco Logo" className="w-24 h-24 object-contain bg-cream rounded-full p-2 mb-6 shadow-lg" loading="lazy" decoding="async" width={96} height={96} data-id="element-54" />
            <h3 className="font-display font-bold text-2xl tracking-widest mb-2" data-id="element-55">
              THE HAPPY TACO
            </h3>
            <p className="text-cream/70 font-script text-2xl" data-id="element-56">
              Comida mexicana fresca y auténtica.
            </p>
          </div>

          {/* Contact Col */}
          <div className="flex flex-col items-center md:items-start" data-id="element-57">
            <h4 className="font-display font-bold text-xl mb-6 tracking-widest uppercase text-orange-light" data-id="element-58">
              Contacto
            </h4>
            <div className="space-y-4" data-id="element-59">
              <div className="flex items-center justify-center md:justify-start gap-3 text-cream/80 hover:text-cream transition-colors" data-id="element-60">
                <MapPin size={20} className="text-orange" data-id="element-61" />
                <span data-id="element-62">Littleton, NC 27850</span>
              </div>
              <a href="tel:+12522131970" className="flex items-center justify-center md:justify-start gap-3 text-cream/80 hover:text-cream transition-colors" data-id="element-63">
                <Phone size={20} className="text-orange" data-id="element-64" />
                <span data-id="element-65">(252) 213-1970</span>
              </a>
            </div>
          </div>

          {/* Social Col */}
          <div className="flex flex-col items-center md:items-start" data-id="element-66">
            <h4 className="font-display font-bold text-xl mb-6 tracking-widest uppercase text-orange-light" data-id="element-67">
              Redes Sociales
            </h4>
            <div className="flex gap-4" data-id="element-68">
              <a href="#" className="bg-cream/10 hover:bg-orange p-3 rounded-full transition-colors" data-id="element-69">
                <Facebook size={24} data-id="element-70" />
              </a>
              <a href="#" className="bg-cream/10 hover:bg-orange p-3 rounded-full transition-colors" data-id="element-71">
                <Instagram size={24} data-id="element-72" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-cream/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-cream/50" data-id="element-73">
          <p data-id="element-74">&copy; 2026 The Happy Taco. All rights reserved.</p>
          <p data-id="element-75">Designed with passion.</p>
        </div>
      </div>
    </footer>;
}